export const coworkingsConstants = {
    LOADING_COWORKINGS_REQUEST: '[Coworkings] Load request',
    LOADING_COWORKINGS_FAILURE: '[Coworkings] Load failure',
    LOADING_COWORKINGS_DONE: '[Coworkings] Load done',
    UPDATE_COWORKINGS: '[Coworkings] Update',
    FETCH: '[Coworkings] Fetch',
    ADD_ITEMS: '[Coworkings] Add Items',
    AJAX_CALL_REQUEST: '[Coworkings] Ajax call request',
    AJAX_CALL_SUCCESS: '[Coworkings] Ajax call success',
    AJAX_CALL_FAILURE: '[Coworkings] Ajax call failed',
}
